// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BusinessAnalyticsSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="BusinessAnalyticsSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="m8.34 6.024 3.446 4.005.078.108a.183.183 0 0 0 .292.009l3.812-4.09a2.124 2.124 0 0 0-2.115-2.016H6.147A2.124 2.124 0 0 0 4.03 6.157v6.06l3.988-6.195a.184.184 0 0 1 .321.002" />
      <path d="M4.03 12.222v-.005l-2.466 3.83a.22.22 0 0 0-.033.135c.012.155.208.262.333.114l2.166-2.394z" />
      <path d="M18.469 3.843c-.013-.155-.208-.262-.333-.114l-2.168 2.327.002.101v1.646l-3.988 6.194a.184.184 0 0 1-.322-.002L8.214 9.8 8.136 9.69a.183.183 0 0 0-.292-.008L4.03 13.897a2.123 2.123 0 0 0 2.117 2.083h7.706a2.124 2.124 0 0 0 2.117-2.117V7.807l2.466-3.83a.22.22 0 0 0 .033-.134" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const BusinessAnalyticsSignetIcon = /* @__PURE__ */ Object.assign(
  BusinessAnalyticsSignetIconComponent,
  { displayName: 'BusinessAnalyticsSignetIcon' },
);
